import { call, put, takeEvery } from "redux-saga/effects"

import { 
    // FINAL DECISIONS
    GET_FINAL_DECISIONS,
    GET_FINAL_DECISIONS_SUCCESS,
    GET_FINAL_DECISIONS_FAIL, 

    GET_RETEST_CANDIDATES,
    GET_RETEST_CANDIDATES_SUCCESS,
    GET_RETEST_CANDIDATES_FAIL,


} from "./actionTypes";

import {
    getFinalDecisionsSuccess, 
    getFinalDecisionsFail,

    getRetestCandidatesSuccess, 
    getRetestCandidatesFail
} from "./actions"

import {
    getFinalDecisions, 
    getRetestCandidates
} from "helpers/final-decisions/final_decisions_backend_helper";

function* fetchFinalDecisions({ payload }) {
    try {
        // Correction : On extrait les variables depuis le payload reçu
        // Le composant envoie { sessionUuid, study_level_id }
        const { session_uuid, study_level_id } = payload;

        console.log("SESSION UUID: ", session_uuid);
        console.log("STUDY LEVEL ID: ", study_level_id);

        // 1. Appel au helper
        const response = yield call(getFinalDecisions, session_uuid, study_level_id);

        console.log("FINAL DECISIONS RESPONSE: ", response);
        
        // 2. Succès : on transmet l'objet complet au reducer
        yield put(getFinalDecisionsSuccess(response));
        
    } catch (error) {
        // 3. Échec : On utilise la fonction de fail importée
        yield put(getFinalDecisionsFail(error.response ? error.response.data : error.message));
    }
}

function* fetchRetestCandidates({ payload }) {
    try {
        const { session_uuid, study_level_id } = payload;
        
        // Appel à la nouvelle méthode helper
        const response = yield call(getRetestCandidates, session_uuid, study_level_id);

        console.log("RETEST CANDIDATES: ", response);
        
        yield put(getRetestCandidatesSuccess(response));
    } catch (error) {
        yield put(getRetestCandidatesFail(error.message));
    }
}


function* finalDecisionSaga() {
    yield takeEvery(GET_FINAL_DECISIONS, fetchFinalDecisions);
    yield takeEvery(GET_RETEST_CANDIDATES, fetchRetestCandidates);
}

export default finalDecisionSaga;